import { WidgetSchema } from '@/entities/widget';

import { AccountBg1, AccountBg7 } from '@/shared/assets';
import { ACC_IMAGES } from '@/shared/config/configs';

export const initialWidgets: WidgetSchema[] = [
  {
    id: '1',
    label: 'Total balance',
    type: 'account-main',
    background: AccountBg7,
    width: 630,
    withMobile: true,
  },

  {
    id: '2',
    label: 'World time',
    type: 'world-time',
    width: 354,
  },

  {
    id: '3',
    label: 'Account',
    type: 'account',
    background: AccountBg1,
    width: 354,
    withMobile: true,
  },

  {
    id: '4',
    label: 'Transactions in process',
    type: 'transactions',
    width: 354,
  },

  {
    id: '5',
    label: 'Total assets',
    type: 'assets',
    width: 354,
  },

  // {
  //   id: '6',
  //   label: 'Statements',
  //   type: 'statements',
  //   width: 354,
  // },
];

export const getAccountWidgetsForCustomize: (
  accs: string[],
) => WidgetSchema[] = (accounts) => {
  const images = Object.entries(ACC_IMAGES).filter((i) =>
    accounts.includes(i[0]),
  );
  return images.map((item, index) => {
    const isTotal = item[0] === 'all';
    return {
      id: item[0],
      label: isTotal ? 'Total balance' : `Account ${item[0]}`,
      type: isTotal ? 'account-main' : 'account',
      background: item[1],
      width: isTotal ? 630 : 354,
    };
  });
};

export const additionalWidgets: WidgetSchema[] = [
  // {
  //   id: '7',
  //   label: 'Account usd',
  //   width: 354,
  //   type: 'account',
  //   background: AccountBg1,
  // },
  // {
  //   id: '8',
  //   label: 'Account eur',
  //   type: 'account',
  //   background: AccountBg1,
  //   width: 354,
  // },
  // {
  //   id: '9',
  //   label: 'Transactions history',
  //   type: 'transactions',
  //   width: 354,
  // },
  // {
  //   id: '10',
  //   label: 'My cards',
  //   type: 'cards',
  //   width: 354,
  // },
  // {
  //   id: '11',
  //   label: 'Favourite payments',
  //   type: 'favorites',
  //   width: 354,
  // },
  // {
  //   id: '12',
  //   label: 'Business news',
  //   type: 'news',
  //   width: 354,
  // },
];
